export default __webpack_public_path__ + "media/metronic/_theme/media/company-logos/logo_client_color-8d6c04e2f9aba7f5f421d32520ae16fa.png";